var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h1',{staticClass:"text-center "},[_vm._v("\n      "+_vm._s(_vm.$route.params.name)+_vm._s(_vm.$route.params.name?',':"")+"欢迎加入我们\n    ")]),_vm._v(" "),_c('img',{staticClass:"img-responsive",attrs:{"src":"https://i.loli.net/2018/12/10/5c0e30682becd.jpg"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37501eba","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = 83
// module chunks = 0